<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0 pt-0">
      <vue-headful title="Ziele" description="Aimz"/>
      <header1 class="mt-10">Meine Ziele</header1>
<!--      <v-row class="ml-5 mt-5" style="min-height: 40px;" v-if="changed">-->
<!--        <v-btn dark @click="save">Speichern</v-btn>-->
<!--        <v-btn class="ml-3" @click="load">Abbrechen</v-btn>-->
<!--      </v-row>-->
      <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
      <v-alert type="error" v-if="error">{{ reason }}</v-alert>
      <v-col class="mx-2 mt-3">
        <div class="headline d-flex mb-5">
          Ab {{CurrentAbDate}}
          <v-btn icon class="gelb ml-5" @click="show_picker=true">
            <v-icon color="dunkelblau">mdi-calendar</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-dialog v-model="show_picker" max-width="290">
            <v-card>
              <v-card-text class="pa-0">
                <v-date-picker v-model="iso_date" :first-day-of-week="1" locale="de"
                               :picker-date.sync="picker_date" :allowed-dates="allowedDates"/>
<!--                :event-color="getDotColor"-->
<!--                :events="pickerMonthAvailability"-->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn width="100" color="gelb" class="white--text" @click="show_picker=false;">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div class="d-flex" v-for="(item,i) in items">
          <p v-if="isVisible(item.activity)">
            <v-icon class="mr-3">mdi-flag</v-icon>
            <span>{{item.activity.name}}</span>:
            <br>
            <v-btn class="ml-9" small @click.stop="onEdit(item)">
              {{item.value}}
            </v-btn>
            <span class="ml-1 grey--text"> {{item.activity.unit}} {{item.activity.freq || "mal pro Woche"}}{{moreInfo(item.activity)}}</span>
          </p>
        </div>
        <div class="d-flex">
          <v-btn class="mr-auto mt-3 mb-3" href="https://youtu.be/lcYm72-GcZk" target="_blank">
            <v-icon class="mr-2">mdi-play-box-outline</v-icon>
            Videoanleitung
          </v-btn>
        </div>
      </v-col>
    </v-container>
    <v-dialog v-model="edit" width="400">
      <v-card>
        <v-card-title>Ziel ändern</v-card-title>
        <v-card-text>
          <v-text-field :label="edit_label" v-model="edit_value" @keyup="onEditKeyUp"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="edit=false">
            Abbrechen
          </v-btn>
          <v-btn color="primary" @click="onEditSave">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";
import Lib from "@/components/ActivityLibrary";
import UserLib from "@/components/UserLib";
import {ArrayX} from "@/reusable/array_extensions";
import Kinds from "@/components/Kinds";
import ActivityLibrary from "@/components/ActivityLibrary";
import {Ziele} from "@/components/Ziele";
import Datum from "@/components/Datum";
const { DateTime } = require("luxon");

//const SETTINGS_CONTEXT = "@team";

export default {
  name: 'ZieleNachDatum',
  components: {CenterContainer, Header1},
  data() {
    return {
      loading: false,
      reason: '',
      error: false,
      year: undefined,
      activities: [],
      ziele: {},
      activityLookup: {},
      items: [], // [{activity, value}, ...] sorted by aname
      edit:false,
      edit_label:"activity",
      edit_value:0,
      edit_activity:undefined,
      show_picker:false,
      iso_date: null,
      picker_date: undefined,
      nextYear:undefined,
      CurrentValues:undefined,
      CurrentAbDate:undefined,
    }
  },
  mounted() {
    this.year=new Date(Date.now()).getFullYear();
    this.nextYear = this.year+1;
    this.iso_date=Datum.to_iso( new Date(Date.now()));
    this.load();
  },
  methods: {
    async load() {
      this.$app.setIntern();
      this.loading = true;
      // --> load activities
      var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY) || [];
      var targets=await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId(this.year));
      this.loading=false;
      console.log({activities, targets});
      this.activities=activities;
      this.activityLookup={};
      activities.forEach(a=>this.activityLookup[a.id]=a);
      this.ziele=targets;
      this.CurrentValues = new Ziele(this.ziele).getCurrentTargets();
      this.CurrentAbDate = this.AbDateFromNow;
      this.updateItems();
    },
    onLoadSuccess(data) {
      this.loading = false;
    },
    onLoadError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
    },
    updateItems() {
      this.items=[];
      var items=[]
      var date = new Date(this.iso_date);
      var dateTime= DateTime.fromJSDate(date);
      var activities=ActivityLibrary.filterActivitiesByDate(this.activities, dateTime);
      activities.forEach(activity=>{
        if (!activity.name)
          return;
        if (activity.type === ActivityLibrary.TYPE_BOOL && activity.freq===ActivityLibrary.FREQ_DAILY)
          return;
        var aid=activity.id;
        //var activity=this.activityLookup[aid];
        var value= this.CurrentValues.hasOwnProperty(aid) ? (this.CurrentValues[aid] || 0) : (activity.target || 0);
        items.push({activity, value})
      });
      this.items=new ArrayX(items).sortBy(x=>x.activity.name);
    },
    isVisible(activity) {
      if (activity.private)
        return false;
      if (activity.type === ActivityLibrary.TYPE_SUMME)
        return false;
      return true;
    },
    onEdit(item) {
      var activity = item.activity;
      var value = item.value;
      this.edit_activity=activity;
      this.edit_label=item.activity.name;
      this.edit_value=value;
      this.edit=true;
    },
    onEditKeyUp(event){
      if (event.keyCode===13)
        this.onEditSave();
      else if (event.keyCode===27)
        this.edit=false;
    },
    onEditSave() {
      this.edit=false;
      var item=this.items.filter(x=>x.activity===this.edit_activity)[0];
      var new_value=parseInt(this.edit_value);
      console.log("New value:", new_value);
      if (new_value===undefined || new_value===null || new_value<0 || isNaN(new_value)) {
        this.$events.$emit("error", "Nur Werte größergleich Null")
        return;
      }
      item.value=new_value;
      var values= this.CurrentValues;
      values[item.activity.id]=new_value;
      this.save();
    },
    save() {
      console.log("Saving", this.ziele)
      var year = new Date(this.ziele.Dates[0].Date).getFullYear();
      this.$backend.set_object(Kinds.KIND_ZIELE, Ziele.makeId(year), this.ziele);
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.settings = data;
      //this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
    allowedDates(date) {
      //console.log(date);
      var date=new Date(date);
      if (date.getFullYear() < this.year || date.getFullYear() > this.nextYear)
        return false;
      if (date.getDate()===1 && date.getMonth()===0)
        return true;
      if (date.getDay()===1) // monday!
        return true;
      return false;
    },
    async initValuesAtDate(date) {
      var newDate=DateTime.fromJSDate(new Date(date));
      var newIso=newDate.toISODate();
      console.log({date, newIso, newDate});
      if (!(newDate.weekday === 1 || (newDate.month === 1 && newDate.day === 1)))  // only mondays or Jan 1st allowed.
      {
        console.log("Not a monday or not Jan 1st", date);
        return;
      }
      if (newDate.year !== new Date(this.CurrentAbDate).getFullYear()) {
        this.loading = true;
        var year=newDate.year;
        this.ziele=await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId(year));
        this.loading=false;
      }
      var ziele=new Ziele(this.ziele);
      var targets=ziele.getTargets(newIso);
      if (targets.Date!==newIso){
        targets=JSON.parse(JSON.stringify(targets));
        targets.Date=newIso;
        ziele.AddTargets(targets);
      }
      this.CurrentValues=targets;
      this.CurrentAbDate=newIso;
      this.updateItems();
    },
    moreInfo(a){
      if (!a)
        return "";
      if (a.lessIsBetter)
        return " (weniger ist besser)";
      return "";
    }
  },
  computed: {
    AbDateFromNow() {
      var now=new Date(Date.now());
      var values= this.CurrentValues;
      //console.log({values});
      if (!values)
        return now.toISOString().substring(0,10);
      return values.Date;
    }
  },
  watch: {
    show_picker(n, o) {
      if (o && !n) {
        this.initValuesAtDate(this.iso_date);
      }
    },
    // settings_edited: {
    //   deep: true,
    //   handler(o, n) {
    //     this.updateEmails();
    //     this.changed = true;
    //   }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>